import axios from "axios";
import { API_URL } from "../constants";

const instance = axios.create({
  baseURL: API_URL
});

instance.interceptors.request.use(
  config => config,
  error => Promise.reject(error)
);
instance.interceptors.response.use(
  response => (response.data ? response.data : response),
  error => Promise.reject(error)
);

const api = {
  getListings: query =>
    instance.get(`/listings`, {
      params: query
    })
};

export default api;
